export function assignRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
export function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (value) {
    refs.forEach(function (ref) {
      return assignRef(ref, value);
    });
  };
}
//# sourceMappingURL=mergeRefs.js.map